import styled from 'styled-components'

export const Root = styled.div.attrs({
  id: 'root-toast'
})`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;

  width: fit-content;

  max-height: 100vh;
  overflow: hidden auto;

  .toast-container {
    padding: 1rem 1rem 0;
  }
`
